// extracted by mini-css-extract-plugin
export default {"toggle":"lsf-toggle","toggle__input":"lsf-toggle__input","toggle__indicator":"lsf-toggle__indicator","toggle_checked":"lsf-toggle_checked","toggle_disabled":"lsf-toggle_disabled"};
    if(module.hot) {
      // 1637785522009
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  